<script lang="ts">
	import Pre from '#lib/html/input/Pre.svelte';
	import { t } from '#lib/stores/i18n.js';
	import { socketStore } from '#lib/stores/socket.js';
	import { ArrowDownLeft, ArrowUpRight, RefreshCw, Wifi, WifiOff } from '@lucide/svelte';
</script>

<div class="space-y-4">
	<!-- Connection State Bar -->
	<div
		class="p-4 rounded-2xl border border-border/60 dark:border-white/10 bg-surface-on/3 dark:bg-white/3 flex items-center justify-between gap-4 flex-wrap"
	>
		<div class="flex items-center gap-3">
			<div
				class="p-2.5 rounded-xl border {$socketStore.connected
					? 'bg-emerald-500/10 text-emerald-500 border-emerald-500/20'
					: 'bg-red-500/10 text-red-500 border-red-500/20'}"
			>
				{#if $socketStore.connected}
					<Wifi class="w-5 h-5" />
				{:else}
					<WifiOff class="w-5 h-5" />
				{/if}
			</div>

			<div>
				<div class="flex items-center gap-2">
					<span class="text-sm font-bold text-surface-on dark:text-white">
						{$socketStore.connected
							? $t('diagnostics.socket.connected')
							: $t('diagnostics.socket.disconnected')}
					</span>
					{#if $socketStore.authenticated}
						<span
							class="px-2 py-0.5 rounded-full text-2xs font-semibold bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20"
						>
							{$t('diagnostics.socket.authenticated')}
						</span>
					{/if}
				</div>
				<p class="text-xs text-surface-on/60 dark:text-slate-400 mt-0.5 font-mono">
					failedToRecover: {$socketStore.failedToRecover ? 'true' : 'false'}
				</p>
			</div>
		</div>

		<div class="flex items-center gap-2">
			<button
				type="button"
				class="px-3.5 py-2 text-xs font-semibold rounded-xl bg-admin text-admin-on hover:opacity-90 active:scale-95 transition-all flex items-center gap-1.5 shadow-sm cursor-pointer"
				onclick={() => socketStore.reconnect()}
			>
				<RefreshCw class="w-3.5 h-3.5" />
				{$t('diagnostics.socket.reconnect')}
			</button>
		</div>
	</div>

	<!-- WebSocket Messages List -->
	<div class="max-h-[50vh] overflow-y-auto space-y-2 pr-1">
		{#if $socketStore.messages.length === 0}
			<div
				class="py-12 text-center text-xs text-surface-on/50 dark:text-slate-400 border border-dashed border-border/60 dark:border-white/10 rounded-2xl"
			>
				{$t('diagnostics.socket.no_messages')}
			</div>
		{:else}
			{#each [...$socketStore.messages].reverse() as msg (msg.id)}
				<div
					class="rounded-xl border border-border/60 dark:border-white/10 bg-surface-on/3 dark:bg-white/3 p-3 text-xs space-y-2"
				>
					<div class="flex items-center justify-between gap-2 flex-wrap font-mono">
						<div class="flex items-center gap-2">
							<span
								class="px-2 py-0.5 rounded-lg text-2xs font-bold uppercase inline-flex items-center gap-1 {msg.direction ===
								'emit'
									? 'bg-blue-500/15 text-blue-600 dark:text-blue-400 border border-blue-500/20'
									: 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20'}"
							>
								{#if msg.direction === 'emit'}
									<ArrowUpRight class="w-3 h-3" /> EMIT
								{:else}
									<ArrowDownLeft class="w-3 h-3" /> RECV
								{/if}
							</span>
							<span class="font-semibold text-surface-on dark:text-white"
								>{msg.type}</span
							>
						</div>
						<span class="text-surface-on/50 dark:text-slate-400 text-2xs"
							>{msg.date}</span
						>
					</div>

					{#if msg.data}
						<div
							class="rounded-lg bg-black text-slate-300 p-2 text-2xs font-mono overflow-x-auto border border-white/10 shadow-inner"
						>
							<Pre>{JSON.stringify(msg.data, null, 2)}</Pre>
						</div>
					{/if}
				</div>
			{/each}
		{/if}
	</div>
</div>
